import React, {useState} from "react";
import {Col, Row} from "reactstrap";
import {ButtonNew} from "../../../components/buttons/buttonsActions";
import EmployeeForm from "./_form";
import EmployeeList from "./_list";

export default function Employee() {

    const [collapseForm, setCollapseForm] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [item, setItem] = useState();

    const toggleForm = () => {
        setEditMode(false);
        setCollapseForm(!collapseForm);
        setItem(null);
    }

    const beginEdit = (data) => {
        setEditMode(true);
        setCollapseForm(!collapseForm);
        setItem(data);
    }

    return (
        <div>
            {/*--------------------------------------------------------------------------------*/}
            {/* Header*/}
            {/*--------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        {
                            !collapseForm ?
                                <div className="ml-auto paddingAdd">
                                    <ButtonNew onClick={toggleForm}/>
                                </div> : null
                        }
                    </div>
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Listado*/}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    {!collapseForm ? <EmployeeList beginEdit={beginEdit}/> : null}
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Formulario*/}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    {collapseForm ? <EmployeeForm toggleParent={toggleForm} item={item}/> : null}
                </Col>
            </Row>
        </div>
    );
}